// extracted by mini-css-extract-plugin
module.exports = {"backIcon":"ErrorPage__backIcon___L9yPN","buttonWrapper":"ErrorPage__buttonWrapper___a5elK","wrapper":"ErrorPage__wrapper___FzA6h"};